import { ChangeDetectorRef, Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';

import { merge, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { emailValidator } from '@core/common-legacy';
import { InfoboxComponent } from '@core/components-infobox-legacy';
import { TranslatePipe } from '@core/i18n-legacy';
import type { DialogComponentI } from '@core/user-interface-legacy';
import {
  ButtonComponent,
  DialogBodyComponent,
  DialogFooterComponent,
  DialogHeaderComponent,
  DialogRef,
  FormFieldComponent,
  InputComponent,
  LabelComponent,
} from '@core/user-interface-legacy';

@Component({
  selector: 'rt-candidate-add-email-dialog',
  templateUrl: './candidate-add-email-dialog.component.html',
  styleUrls: ['./candidate-add-email-dialog.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    DialogHeaderComponent,
    DialogBodyComponent,
    FormFieldComponent,
    LabelComponent,
    InputComponent,
    ReactiveFormsModule,
    DialogFooterComponent,
    ButtonComponent,
    TranslatePipe,
    InfoboxComponent,
  ],
})
export class CandidateAddEmailDialogComponent implements DialogComponentI<
  null,
  { email: string } | null
> {
  private readonly cdRef = inject(ChangeDetectorRef);
  private readonly dialogRef = inject(DialogRef);

  public emailControl = new FormControl('', [Validators.required, emailValidator]);

  private ngOnDestroy$ = new Subject<void>();

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public setDialogData(data: null, triggerUpdate: boolean): void {}

  public ngOnInit(): void {
    merge(this.emailControl.valueChanges, this.emailControl.statusChanges)
      .pipe(takeUntil(this.ngOnDestroy$.asObservable()))
      .subscribe(() => this.cdRef.detectChanges());
  }

  public ngOnDestroy(): void {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }

  public cancel() {
    this.dialogRef.close(null);
  }

  public save() {
    this.dialogRef.close({
      email: this.emailControl.value,
    });
  }
}
